// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"SectionTitle_SectionTitle__3YQqk","Span":"SectionTitle_Span__31btu","Red":"SectionTitle_Red__r13jY","Blue":"SectionTitle_Blue__1xXfA"};